var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle2, _circle3, _circle4, _circle5, _circle6, _path14, _path15, _circle7, _path16, _path17, _circle8, _circle9, _path18, _circle0, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);}\n\t.st1{opacity:0.5;fill:url(#SVGID_00000010297953631067376630000013528507421191827604_);}\n\t.st2{opacity:0.7;fill:url(#SVGID_00000158724801307695114990000008141525487484382393_);}\n\t.st3{opacity:0.3;fill:url(#SVGID_00000179639426224128868830000014313322027901025935_);}\n\t.st4{opacity:0.2;fill:url(#SVGID_00000181785515288650142280000015692298919011877536_);}\n\t.st5{fill:url(#SVGID_00000087389184270103364570000005716899836896077956_);}\n\t.st6{opacity:0.3;fill:url(#SVGID_00000015355454837954060830000010697023999119628220_);}\n\t.st7{fill:url(#SVGID_00000056421688379731232940000012901019136738989989_);}\n\t.st8{fill:url(#SVGID_00000088811225564605459660000007160524906122296742_);}\n\t.st9{fill:url(#SVGID_00000021838627563045209790000010586084751631541888_);}\n\t.st10{opacity:0.2;fill:url(#SVGID_00000103962035623045488570000010478395232569499269_);}\n\t.st11{fill:url(#SVGID_00000037685392451495731720000011585223129059890842_);}\n\t.st12{fill:url(#SVGID_00000057130236237873420780000009948352360068271517_);}\n\t.st13{fill:url(#SVGID_00000011746621278279913430000004373517951045554854_);}\n\t.st14{fill:url(#SVGID_00000079460804577001422430000010654380842661649853_);}\n\t.st15{fill:url(#SVGID_00000096761656933978153550000006877275369502054018_);}\n\t.st16{fill:url(#SVGID_00000143578313682370972590000013718520823627396279_);}\n\t.st17{opacity:0.2;fill:url(#SVGID_00000105389081429668789880000001918567990506400394_);}\n\t.st18{opacity:0.2;fill:url(#SVGID_00000071536532624517736240000009484602494661240726_);}\n\t.st19{opacity:0.2;fill:url(#SVGID_00000170965468545961799690000000028196924698666942_);}\n\t.st20{opacity:0.2;fill:url(#SVGID_00000110429803326192344280000002415281224332595858_);}\n\t.st21{opacity:0.2;fill:url(#SVGID_00000002361670236013270700000015676631543507430809_);}\n\t.st22{fill:url(#SVGID_00000003787785211236761940000002010135199247999116_);}\n\t.st23{fill:url(#SVGID_00000047019302822965564620000009722007655717076918_);}\n\t.st24{fill:url(#SVGID_00000065796921020691971400000006429853232580022694_);}\n\t.st25{opacity:0.2;fill:url(#SVGID_00000166648724685227226470000010929219582138756243_);}\n\t.st26{fill:url(#SVGID_00000006677996718138872190000015170146919274262404_);}\n\t.st27{opacity:0.2;fill:url(#SVGID_00000119832170722326194540000015994327562931178425_);}\n\t.st28{opacity:0.2;fill:url(#SVGID_00000160899259418584154700000014201681187787605895_);}\n\t.st29{fill:url(#SVGID_00000021114139223644984280000017079109728590776230_);}\n\t.st30{opacity:0.3;fill:url(#SVGID_00000046302933004234232030000005642787937197012615_);}\n\t.st31{fill:url(#SVGID_00000111908221222518890760000016543353498914623887_);}\n\t.st32{fill:url(#SVGID_00000010280962396543573040000014169521163185374634_);}\n\t.st33{opacity:0.2;fill:url(#SVGID_00000003062917589969851510000010629881912513620640_);}\n\t.st34{fill:url(#SVGID_00000035522337903827747470000003037138193623255954_);}\n\t.st35{opacity:0.2;fill:url(#SVGID_00000003078820035901064410000003441296787572023190_);}\n\t.st36{opacity:0.2;fill:url(#SVGID_00000138558208465902873240000005512107805191168930_);}\n\t.st37{opacity:0.2;fill:url(#SVGID_00000067214757459326598630000011669790227782777262_);}\n\t.st38{opacity:0.2;fill:url(#SVGID_00000114755193986212521540000016536024852518183296_);}\n\t.st39{fill:url(#SVGID_00000055693007362539191490000002689681646012879268_);}\n\t.st40{opacity:0.5;fill:url(#SVGID_00000136380956606301918130000017299029057179867783_);}\n\t.st41{opacity:0.4;fill:url(#SVGID_00000122000985975722639630000011187837461721532576_);}\n\t.st42{opacity:0.7;fill:url(#SVGID_00000109743749892055970600000002027317470694350720_);}\n\t.st43{opacity:0.2;fill:url(#SVGID_00000165236468118016026650000001470307619765779891_);}\n\t.st44{opacity:0.2;fill:url(#SVGID_00000176736569622244556080000003263097695895279514_);}\n\t.st45{opacity:0.5;fill:url(#SVGID_00000152259563525082231250000013263828083156639391_);}\n\t.st46{opacity:0.5;fill:url(#SVGID_00000146466957688908929390000015723753177703153816_);}\n\t.st47{opacity:0.7;fill:url(#SVGID_00000152973481208072116380000001208073429972077192_);}\n\t.st48{opacity:0.5;fill:url(#SVGID_00000165192493228142879250000017434546901014944430_);}\n\t.st49{opacity:0.9;fill:url(#SVGID_00000025435385548898543420000010971393643752387254_);}\n\t.st50{opacity:0.9;fill:url(#SVGID_00000083048972120189928880000012198926758770773915_);}\n\t.st51{opacity:0.9;fill:url(#SVGID_00000053513437027125485400000000952470476496457095_);}\n\t.st52{opacity:0.9;fill:url(#SVGID_00000083050967246409116360000005371617597567244698_);}\n\t.st53{opacity:0.9;fill:url(#SVGID_00000051382432971665917510000007910102919350708641_);}\n\t.st54{opacity:0.5;fill:url(#SVGID_00000027595539726427690180000017713176721879836095_);}\n\t.st55{opacity:0.5;fill:url(#SVGID_00000181089017330871576480000005849205227351663769_);}\n\t.st56{opacity:0.5;fill:url(#SVGID_00000048492367871344119740000007513015657355553962_);}\n\t.st57{opacity:0.5;fill:url(#SVGID_00000070813796567853604250000010010253179238603649_);}\n\t.st58{opacity:0.9;fill:url(#SVGID_00000045603429963932273570000000739832503123741323_);}\n\t.st59{opacity:0.9;fill:url(#SVGID_00000121984337790908350990000017797538415526662789_);}\n\t.st60{opacity:0.5;fill:url(#SVGID_00000034077640107394556270000018311533594855624082_);}\n\t.st61{opacity:0.5;fill:url(#SVGID_00000090973625848049299220000016364245892594203805_);}\n\t.st62{opacity:0.5;fill:url(#SVGID_00000090290825783683849860000000296407106764456343_);}\n\t.st63{opacity:0.5;fill:url(#SVGID_00000010269319364332585350000011729696573487040914_);}\n\t.st64{opacity:0.5;fill:url(#SVGID_00000136395467189910501220000000312907410195706281_);}\n\t.st65{opacity:0.5;fill:url(#SVGID_00000168108773943355063620000016635256521958871975_);}\n\t.st66{opacity:0.5;fill:url(#SVGID_00000165200451155462668400000013987293045814330024_);}\n\t.st67{opacity:0.5;fill:url(#SVGID_00000143613626193515355200000003590311716168094140_);}\n\t.st68{opacity:0.5;fill:url(#SVGID_00000150819987539631947480000013163765909767712915_);}\n\t.st69{opacity:0.3;fill:url(#SVGID_00000033361262508125719210000006315769943222768544_);}\n\t.st70{opacity:0.5;fill:url(#SVGID_00000064348887773185410590000012862090639052442280_);}\n\t.st71{fill:url(#SVGID_00000167387868704440168150000010177748078355063944_);}\n\t.st72{opacity:0.5;fill:url(#SVGID_00000134244091448932363420000010269122293464624561_);}\n\t.st73{opacity:0.3;fill:url(#SVGID_00000103986311381260362810000013300021543346760119_);}\n\t.st74{opacity:0.3;fill:url(#SVGID_00000013883490603308176550000014825003513815770814_);}\n\t.st75{opacity:0.5;fill:url(#SVGID_00000036943362280984538280000002431856274516066750_);}\n\t.st76{opacity:0.3;fill:url(#SVGID_00000179610206016873539020000012040789782798749341_);}\n\t.st77{opacity:0.5;fill:url(#SVGID_00000109727547519499173100000004317678042674189239_);}\n\t.st78{fill:url(#SVGID_00000037665003750082158640000017211650007322065852_);}\n\t.st79{fill:url(#SVGID_00000082354619965364613480000018159824097227025837_);}\n\t.st80{opacity:0.5;fill:url(#SVGID_00000080897155278324550080000005069355116180862616_);}\n\t.st81{opacity:0.5;fill:url(#SVGID_00000078036632367051619340000012223005065498358676_);}\n\t.st82{opacity:0.5;fill:url(#SVGID_00000024714564365402150430000009054816425119323795_);}\n\t.st83{fill:url(#SVGID_00000155117488602967830480000017291984215441317793_);}\n\t.st84{opacity:0.3;fill:url(#SVGID_00000080923884468970987420000003457029150345736357_);}\n\t.st85{opacity:0.5;fill:url(#SVGID_00000048480592965997363390000006017286392654152585_);}\n\t.st86{fill:url(#SVGID_00000003101148750785876420000002206010510369416120_);}\n\t.st87{opacity:0.3;fill:url(#SVGID_00000053536682427716425290000006423485772035955116_);}\n\t.st88{fill:url(#SVGID_00000072999606975385277020000012162536964284991931_);}\n\t.st89{opacity:0.3;fill:url(#SVGID_00000091693474350634289570000010115957583204745375_);}\n\t.st90{fill:url(#SVGID_00000125577857652896413530000015956921657979621796_);}\n\t.st91{opacity:0.8;fill:url(#SVGID_00000098925313359919820730000014779639692355798971_);}\n\t.st92{opacity:0.8;fill:url(#SVGID_00000020396702940058340480000002813579975481697684_);}\n\t.st93{opacity:0.8;fill:url(#SVGID_00000125576936785752219590000013621654641533687219_);}\n\t.st94{opacity:0.8;fill:url(#SVGID_00000023255407830237592120000010625827411143502490_);}\n\t.st95{opacity:0.2;}\n\t.st96{opacity:0.8;fill:url(#SVGID_00000063593334777215154760000007361264105482905247_);}\n\t.st97{opacity:0.8;fill:url(#SVGID_00000057136899204247964320000014524991634543695034_);}\n\t.st98{opacity:0.6;}\n\t.st99{opacity:0.8;fill:url(#SVGID_00000049193138442079405320000017181656732023487363_);}\n\t.st100{opacity:0.8;fill:url(#SVGID_00000106840072133113895390000016079939171311653003_);}\n\t.st101{opacity:0.3;}\n\t.st102{opacity:0.8;fill:url(#SVGID_00000176756176002809332920000007903383307202415794_);}\n\t.st103{opacity:0.8;fill:url(#SVGID_00000094620615365692624660000004087511320181819532_);}\n\t.st104{opacity:0.8;fill:url(#SVGID_00000066477559573739051150000011979437650998524066_);}\n\t.st105{opacity:0.8;fill:url(#SVGID_00000021834533458785669160000012061616225102665912_);}\n\t.st106{opacity:0.8;fill:url(#SVGID_00000029044243118373551940000011947071980124379777_);}\n\t.st107{opacity:0.8;fill:url(#SVGID_00000178906220791170104950000008263687215372534442_);}\n\t.st108{opacity:0.8;fill:url(#SVGID_00000142165098180607247960000016732097281607894915_);}\n\t.st109{opacity:0.8;fill:url(#SVGID_00000031894357505408026600000006989017998320739487_);}\n\t.st110{opacity:0.8;fill:url(#SVGID_00000032622689181363726870000016804874673987468694_);}\n\t.st111{opacity:0.8;fill:url(#SVGID_00000075124611502259911540000002868758304814901155_);}\n\t.st112{opacity:0.8;fill:url(#SVGID_00000101782607016051612410000011290099908026533798_);}\n\t.st113{opacity:0.8;fill:url(#SVGID_00000091717886996658098210000012578515968284220825_);}\n\t.st114{opacity:0.8;fill:url(#SVGID_00000169516661721787226880000010327649607652460467_);}\n\t.st115{opacity:0.8;fill:url(#SVGID_00000097469222522226212120000014280365129203289473_);}\n\t.st116{opacity:0.8;fill:url(#SVGID_00000041280345467470868140000005187004600402552201_);}\n\t.st117{opacity:0.8;fill:url(#SVGID_00000098207536098786327830000006151014279545891734_);}\n\t.st118{opacity:0.8;fill:url(#SVGID_00000170271166924788561150000018439998843156254102_);}\n\t.st119{opacity:0.8;fill:url(#SVGID_00000128480820344020463930000017722348603123432624_);}\n\t.st120{opacity:0.3;fill:url(#SVGID_00000045615552490677397970000001919994844010389183_);}\n\t.st121{opacity:0.3;fill:url(#SVGID_00000178926727264355147470000014710855800536221606_);}\n\t.st122{opacity:0.3;fill:url(#SVGID_00000114032630069371078710000012619082508616285332_);}\n\t.st123{opacity:0.3;fill:url(#SVGID_00000129906912160158379040000011899909137420637611_);}\n\t.st124{fill:#FFFFFF;}\n\t.st125{opacity:0.2;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 234.2056,
    cy: 219.0809,
    r: 164.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07125176,
    style: {
      stopColor: "#F6FADB",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    style: {
      stopColor: "#E9F4A9",
      stopOpacity: 0.7946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2974,
    style: {
      stopColor: "#DEEE7F",
      stopOpacity: 0.6661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    style: {
      stopColor: "#D5E95C",
      stopOpacity: 0.5368
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5287,
    style: {
      stopColor: "#CEE641",
      stopOpacity: 0.4065
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    style: {
      stopColor: "#C9E32D",
      stopOpacity: 0.2747
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7657,
    style: {
      stopColor: "#C6E222",
      stopOpacity: 0.1404
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    style: {
      stopColor: "#C5E11E",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 234.2,
    cy: 220.3,
    r: 180.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114040110207037388280000007524405740961278891_",
    cx: 234.2056,
    cy: 219.6671,
    r: 82.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009700408,
    style: {
      stopColor: "#FCFDF3",
      stopOpacity: 0.9858
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04818773,
    style: {
      stopColor: "#F0F7C6",
      stopOpacity: 0.9296
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09062584,
    style: {
      stopColor: "#E6F29E",
      stopOpacity: 0.8677
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    style: {
      stopColor: "#DDED7B",
      stopOpacity: 0.8013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1855,
    style: {
      stopColor: "#D6EA5E",
      stopOpacity: 0.7292
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2401,
    style: {
      stopColor: "#CFE647",
      stopOpacity: 0.6494
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3021,
    style: {
      stopColor: "#CBE434",
      stopOpacity: 0.5589
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3759,
    style: {
      stopColor: "#C7E228",
      stopOpacity: 0.4511
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    style: {
      stopColor: "#C6E120",
      stopOpacity: 0.3091
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6848,
    style: {
      stopColor: "#C5E11E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000114040110207037388280000007524405740961278891_)"
    },
    cx: 234.2,
    cy: 220.3,
    r: 90.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021824020778061442930000009764728654510085790_",
    cx: 228.1697,
    cy: 276.6141,
    r: 92.6696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1272,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5037,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5982,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6907,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8622,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000021824020778061442930000009764728654510085790_)"
    },
    points: "222.7,434  240.9,434 231.8,264.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124868756444945175990000017459843063655665329_",
    cx: 227.4371,
    cy: 253.0266,
    r: 155.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09749732,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2267,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3181,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7327,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000124868756444945175990000017459843063655665329_)"
    },
    points: "346.3,422.9  363.5,389 247.3,242.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150064103908797448780000009580914866288347274_",
    cx: 298.1418,
    cy: 272.8773,
    r: 107.8819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000150064103908797448780000009580914866288347274_)"
    },
    points: "444,411.7  449.5,405.5 289.6,268.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150790783154074918650000012348984961854779557_",
    cx: 323.1059,
    cy: 267.5131,
    r: 114.3294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150790783154074918650000012348984961854779557_)"
    },
    points: "501,357.5 504.5,349.9  311.9,265  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000182504085032244740690000000443828246155761074_",
    cx: 149.4532,
    cy: 258.0543,
    r: 150.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000182504085032244740690000000443828246155761074_)"
    },
    points: "-14.5,353.6  -20.8,384.6 190.7,252.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057862123498100890240000005221666081665602740_",
    cx: 209.1938,
    cy: 275.8678,
    r: 96.4864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057862123498100890240000005221666081665602740_)"
    },
    points: "140.4,479.8 148.4,482.3  213.7,274.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150102676158495916980000013664607449813428128_",
    cx: 179.45,
    cy: 270.5769,
    r: 134.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150102676158495916980000013664607449813428128_)"
    },
    points: "11.1,391 14.4,395.5  182.3,268.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057852830534659175650000018196766583675175861_",
    cx: 137.8045,
    cy: 237.7137,
    r: 114.6173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057852830534659175650000018196766583675175861_)"
    },
    points: "-48.3,264.3 -47.4,269.9  159.8,233.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000156585996432796901210000014730878595735252649_",
    cx: 140.0191,
    cy: 198.5096,
    r: 104.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009556049,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1046,
    style: {
      stopColor: "#CEF88F",
      stopOpacity: 0.8844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2332,
    style: {
      stopColor: "#BDE984",
      stopOpacity: 0.7281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#A0D071",
      stopOpacity: 0.5484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    style: {
      stopColor: "#79AE58",
      stopOpacity: 0.3514
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    style: {
      stopColor: "#478337",
      stopOpacity: 0.1427
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#20621E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000156585996432796901210000014730878595735252649_)"
    },
    points: "-37.9,148.5  -39.3,153.9 164.9,204.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151516619286703108740000001491202446053869959_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1866,
    y1: 129.1407,
    x2: 182.905,
    y2: 129.1407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#20621E",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    style: {
      stopColor: "#478337",
      stopOpacity: 0.1427
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    style: {
      stopColor: "#79AE58",
      stopOpacity: 0.3514
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#A0D071",
      stopOpacity: 0.5484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7668,
    style: {
      stopColor: "#BDE984",
      stopOpacity: 0.7281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8954,
    style: {
      stopColor: "#CEF88F",
      stopOpacity: 0.8844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    style: {
      stopColor: "#D4FD93"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000151516619286703108740000001491202446053869959_)"
    },
    points: "-19.4,74.9 -22.3,79.7  160.8,183.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007414358816951373920000008059627499926684065_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.8287,
    y1: 94.57,
    x2: 234.155,
    y2: 94.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#20621E",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    style: {
      stopColor: "#478337",
      stopOpacity: 0.1427
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    style: {
      stopColor: "#79AE58",
      stopOpacity: 0.3514
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#A0D071",
      stopOpacity: 0.5484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7668,
    style: {
      stopColor: "#BDE984",
      stopOpacity: 0.7281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8954,
    style: {
      stopColor: "#CEF88F",
      stopOpacity: 0.8844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    style: {
      stopColor: "#D4FD93"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007414358816951373920000008059627499926684065_)"
    },
    points: "55.9,14.3 51.7,18 192,174.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000084495349804524918450000007943727808680614064_",
    cx: 224.4906,
    cy: 160.5684,
    r: 109.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000084495349804524918450000007943727808680614064_)"
    },
    points: "213.9,36 208.3,36.5 223.9,173  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096020340054692467890000018076233033906526623_",
    cx: 257.4776,
    cy: 164.2135,
    r: 70.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096020340054692467890000018076233033906526623_)"
    },
    points: "288.9,52.6 283.4,51.2  251.7,184.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072272378423518904330000012915053703459500180_",
    cx: 246.0353,
    cy: 317.8777,
    r: 82.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000072272378423518904330000012915053703459500180_)"
    },
    points: "272.8,495.1 281.1,493.8  243.3,286.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000025427316490451957380000001562502155232082820_",
    cx: 157.646,
    cy: 204.9498,
    r: 144.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000025427316490451957380000001562502155232082820_)"
    },
    points: "-30.5,170.4 -32.3,178.5  188.1,218  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026871121149958082280000009810466637853393537_",
    cx: 169.7139,
    cy: 161.2768,
    r: 115.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000026871121149958082280000009810466637853393537_)"
    },
    points: "17.7,45.7  12.5,52.3 179.9,179.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082337567499949297380000010530149204635674252_",
    cx: 195.0959,
    cy: 121.3976,
    r: 127.9448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000082337567499949297380000010530149204635674252_)"
    },
    points: "113.9,-39.3  106.3,-35.7 201.8,151.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000079477282149718249770000009327507371998067589_",
    cx: 277.1982,
    cy: 145.6841,
    r: 71.5185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000079477282149718249770000009327507371998067589_)"
    },
    points: "325.6,40.5  317.9,37.2 272.6,154.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000036954038025651505320000001112747068783755177_",
    cx: 329.9713,
    cy: 204.6668,
    r: 66.5115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000036954038025651505320000001112747068783755177_)"
    },
    points: "440.7,194  439.4,185.7 315.6,209.2  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000034091355854835705000000010785827649849828263_",
    cx: 328.7476,
    cy: 151.1865,
    r: 107.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000034091355854835705000000010785827649849828263_)"
    },
    points: "420.7,75.6  417.7,72.2 324.3,156.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000067958745856722693070000000402202867800479405_",
    cx: 299.6667,
    cy: 240.8664,
    r: 96.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067958745856722693070000000402202867800479405_)"
    },
    points: "440.5,273.3 441.5,268.3  302.7,240.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173137159556037200030000014398776004986113682_",
    cx: 312.7292,
    cy: 270.8623,
    r: 88.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173137159556037200030000014398776004986113682_)"
    },
    points: "408.8,340.9 411.6,336.7  292.8,259.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119115187950233972950000010436936893854977180_",
    cx: 279.4202,
    cy: 264.9151,
    r: 90.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000119115187950233972950000010436936893854977180_)"
    },
    points: "356,365.6 359.9,362.3  266.6,255.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000044165981408919802050000004947875948447332762_",
    cx: 267.1607,
    cy: 298.7173,
    r: 69.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000044165981408919802050000004947875948447332762_)"
    },
    points: "326,405.8  330.4,403.3 260.3,280.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078018968862758790610000008029030263248102296_",
    cx: 249.3681,
    cy: 278.3198,
    r: 83.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000078018968862758790610000008029030263248102296_)"
    },
    points: "276.4,397.4 281.3,396.1  243,259.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000112601390329789702860000000221101975939047341_",
    cx: 220.3416,
    cy: 279.9232,
    r: 69.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000112601390329789702860000000221101975939047341_)"
    },
    points: "199.2,412  204.2,412.7 221.5,272.2  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018235385425857011280000000295623057409210805_",
    cx: 169.361,
    cy: 293.936,
    r: 79.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000018235385425857011280000000295623057409210805_)"
    },
    points: "70.5,376.1  73.9,379.9 177,282.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090993169780476792460000011055408337006239112_",
    cx: 131.967,
    cy: 270.4578,
    r: 87.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090993169780476792460000011055408337006239112_)"
    },
    points: "30.7,315 32.8,319.6  145.9,267.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021083623867992172190000014210703530039300256_",
    cx: 339.7095,
    cy: 150.3959,
    r: 123.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07667107,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2851,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3267,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4549,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5804,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7002,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9159,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000021083623867992172190000014210703530039300256_)"
    },
    points: "459.8,84.5  464.8,50.3 351.3,148.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127738355726553971550000002106676277688897186_",
    cx: 327.7366,
    cy: 168.6648,
    r: 87.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127738355726553971550000002106676277688897186_)"
    },
    points: "476.2,100.7 472.4,93.2  286.7,192.2  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000180369051646575676750000002016387077758488233_",
    cx: 302.4599,
    cy: 164.0236,
    r: 101.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0446652,
    style: {
      stopColor: "#F8F5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09459634,
    style: {
      stopColor: "#F2EA97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1455,
    style: {
      stopColor: "#ECE26A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1963,
    style: {
      stopColor: "#E8DB46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2471,
    style: {
      stopColor: "#E4D52A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2979,
    style: {
      stopColor: "#E2D116"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3486,
    style: {
      stopColor: "#E0CF0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3995,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7277,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180369051646575676750000002016387077758488233_)"
    },
    points: "372.5,102.3 366.6,96.4  299.1,169.1  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000060742546032112456350000016889435485915987618_",
    cx: 312.6175,
    cy: 229.993,
    r: 123.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09526998,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000060742546032112456350000016889435485915987618_)"
    },
    points: "506.5,259.8  507.5,251.5 298.2,229.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000086661772378054245210000006129392252686466440_",
    cx: 294.9107,
    cy: 213.6601,
    r: 117.4778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086661772378054245210000006129392252686466440_)"
    },
    points: "514.9,217.5 514.5,209.1  270.3,220.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121239414292116373040000001665578910602417549_",
    cx: 296.6584,
    cy: 242.1755,
    r: 117.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06146643,
    style: {
      stopColor: "#F4FEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    style: {
      stopColor: "#E6FEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    style: {
      stopColor: "#DCFDA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3078,
    style: {
      stopColor: "#D6FD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3698,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4179,
    style: {
      stopColor: "#CEF790",
      stopOpacity: 0.8958
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#BDE787",
      stopOpacity: 0.7549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5579,
    style: {
      stopColor: "#A0CC79",
      stopOpacity: 0.593
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#79A765",
      stopOpacity: 0.4154
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    style: {
      stopColor: "#46774B",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8197,
    style: {
      stopColor: "#093D2C",
      stopOpacity: 0.0266909
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000121239414292116373040000001665578910602417549_)"
    },
    points: "430.7,301.5  436.3,284.2 289.6,245.1  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023281034074783209010000003851853745554176391_",
    cx: 283.3244,
    cy: 219.0219,
    r: 160.8962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06146643,
    style: {
      stopColor: "#F4FEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    style: {
      stopColor: "#E6FEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    style: {
      stopColor: "#DCFDA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3078,
    style: {
      stopColor: "#D6FD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3698,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4179,
    style: {
      stopColor: "#CEF790",
      stopOpacity: 0.8958
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#BDE787",
      stopOpacity: 0.7549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5579,
    style: {
      stopColor: "#A0CC79",
      stopOpacity: 0.593
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#79A765",
      stopOpacity: 0.4154
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    style: {
      stopColor: "#46774B",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8197,
    style: {
      stopColor: "#093D2C",
      stopOpacity: 0.0266909
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000023281034074783209010000003851853745554176391_)"
    },
    points: "463.6,178.8  431.4,150 296.5,204.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090976530013438961170000006631236867952983461_",
    cx: 279.4736,
    cy: 171.7335,
    r: 99.8314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.091851,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2135,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2997,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3416,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3798,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7239,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9226,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000090976530013438961170000006631236867952983461_)"
    },
    points: "376.6,50.6  361.8,39.9 260.3,196.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000003099705668321302300000016923877836147649165_",
    cx: 233.3511,
    cy: 198.5111,
    r: 101.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02906154,
    style: {
      stopColor: "#F4FEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07046648,
    style: {
      stopColor: "#E6FEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1097,
    style: {
      stopColor: "#DCFDA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1455,
    style: {
      stopColor: "#D6FD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1748,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2433,
    style: {
      stopColor: "#CEF790",
      stopOpacity: 0.8958
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3359,
    style: {
      stopColor: "#BDE787",
      stopOpacity: 0.7549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4423,
    style: {
      stopColor: "#A0CC79",
      stopOpacity: 0.593
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    style: {
      stopColor: "#79A765",
      stopOpacity: 0.4154
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    style: {
      stopColor: "#46774B",
      stopOpacity: 0.225
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8145,
    style: {
      stopColor: "#093D2C",
      stopOpacity: 0.0266909
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000003099705668321302300000016923877836147649165_)"
    },
    points: "243.3,11.5  225.1,11.5 234.2,197.5  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132795434488919525270000004645009276245688719_",
    cx: 250.3237,
    cy: 148.5085,
    r: 84.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2425,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3404,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4235,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6408,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8399,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000132795434488919525270000004645009276245688719_)"
    },
    points: "283.4,-22.9 265.4,-25.5  247.3,159.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000054965874286788140820000015012673050665305221_",
    cx: 140.889,
    cy: 225.1637,
    r: 102.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009556049,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1046,
    style: {
      stopColor: "#CEF88F",
      stopOpacity: 0.8844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2332,
    style: {
      stopColor: "#BDE984",
      stopOpacity: 0.7281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#A0D071",
      stopOpacity: 0.5484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    style: {
      stopColor: "#79AE58",
      stopOpacity: 0.3514
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    style: {
      stopColor: "#478337",
      stopOpacity: 0.1427
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#20621E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000054965874286788140820000015012673050665305221_)"
    },
    points: "-41.4,228  -40.6,246.2 144.8,228.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026847859373554755470000017571478963675661243_",
    cx: 196.456,
    cy: 166.7963,
    r: 152.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000026847859373554755470000017571478963675661243_)"
    },
    points: "117.2,45.8  102.4,56.5 211,187.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000003806399861551309950000011540285248049675451_",
    cx: 170.2937,
    cy: 183.2072,
    r: 157.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1272,
    style: {
      stopColor: "#EEF6BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#D8EB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    style: {
      stopColor: "#CAE432"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5037,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5982,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6907,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8622,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000003806399861551309950000011540285248049675451_)"
    },
    points: "9.1,112.2  31.3,158.7 183.5,201.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000160905430091566879540000004910376318562231184_",
    cx: 189.1473,
    cy: 238.9371,
    r: 192.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05806434,
    style: {
      stopColor: "#B2D01F",
      stopOpacity: 0.9419
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    style: {
      stopColor: "#7CA222",
      stopOpacity: 0.7625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#507B24",
      stopOpacity: 0.587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#2D5C26",
      stopOpacity: 0.4194
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7384,
    style: {
      stopColor: "#144727",
      stopOpacity: 0.2616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    style: {
      stopColor: "#053A28",
      stopOpacity: 0.1176
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000160905430091566879540000004910376318562231184_)"
    },
    points: "23.2,280.4  28.8,297.7 201.8,230.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000074440970835281285040000002209596391120356492_",
    cx: 214.9185,
    cy: 252.0614,
    r: 121.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3656,
    style: {
      stopColor: "#E0CE06"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    style: {
      stopColor: "#D2CB09",
      stopOpacity: 0.9047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5687,
    style: {
      stopColor: "#B6C40E",
      stopOpacity: 0.6798
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7123,
    style: {
      stopColor: "#A2C012",
      stopOpacity: 0.4535
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8559,
    style: {
      stopColor: "#96BD14",
      stopOpacity: 0.2271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BC15",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000074440970835281285040000002209596391120356492_)"
    },
    points: "100.5,387.6  115.2,398.3 220.3,244.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183964178232104338740000001398130472126020754_",
    cx: 7173.0024,
    cy: 998.1481,
    r: 34.3182,
    gradientTransform: "matrix(0.3214 0.217 -2.0961 3.1059 -45.3754 -4337.0874)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000183964178232104338740000001398130472126020754_)"
    },
    d: "M177.6,326.2 c-35.2,52.2-68.2,91.5-73.6,87.9c-5.4-3.6,18.8-48.9,54-101.1c35.2-52.2,68.2-91.5,73.6-87.9C237,228.8,212.8,274,177.6,326.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000053522369520892912320000002548114734178810552_",
    cx: 537.2687,
    cy: 172.8612,
    r: 34.3166,
    gradientTransform: "matrix(-0.2793 -0.2691 2.5993 -2.6988 19.1825 759.2359)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000053522369520892912320000002548114734178810552_)"
    },
    d: "M309.9,140 c43.7-45.3,82.9-78.4,87.6-73.9c4.7,4.5-26.9,44.9-70.6,90.3c-43.7,45.3-82.9,78.4-87.6,73.9C234.7,225.7,266.3,185.3,309.9,140z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000089531909643412808730000016291412981453747129_",
    cx: 9343.957,
    cy: 269.6216,
    r: 10.755,
    gradientTransform: "matrix(-9.430000e-02 -5.530000e-02 1.8929 -3.2337 675.5827 1498.6151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000089531909643412808730000016291412981453747129_)"
    },
    d: "M303.9,109.5 c10-17,18.5-30.6,18.9-30.3c0.5,0.3-7.2,14.3-17.1,31.4c-10,17-18.5,30.6-18.9,30.3C286.3,140.6,293.9,126.5,303.9,109.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075843497228123816220000001018953460649933196_",
    cx: 302.0677,
    cy: 447.3082,
    r: 10.7528,
    gradientTransform: "matrix(-0.1033 3.580000e-02 -1.2288 -3.5398 784.2785 1705.1399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000075843497228123816220000001018953460649933196_)"
    },
    d: "M202.4,132.9 c-6.5-18.6-11.3-33.9-10.7-34.1c0.5-0.2,6.2,14.8,12.7,33.4c6.5,18.6,11.3,33.9,10.7,34.1C214.6,166.5,208.9,151.6,202.4,132.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106131109305441346960000008970636253250610055_",
    cx: 2037.708,
    cy: 678.0192,
    r: 45.4644,
    gradientTransform: "matrix(-1.130000e-02 -0.3877 3.7454 -0.1097 -2132.05 1082.4128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000106131109305441346960000008970636253250610055_)"
    },
    d: "M383.9,202.4 c83.4-2.4,151.2,2.6,151.4,11.2c0.3,8.6-67.1,17.6-150.5,20c-83.4,2.4-151.2-2.6-151.4-11.2C233.1,213.8,300.5,204.8,383.9,202.4 z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000043441576581648873540000011417628729644855212_",
    cx: 2228.7759,
    cy: 700.4583,
    r: 45.4676,
    gradientTransform: "matrix(7.080000e-02 -0.3813 3.6842 0.683 -2660.5098 569.1733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000043441576581648873540000011417628729644855212_)"
    },
    d: "M80.8,182.4 c82,15.2,147.2,34.4,145.7,42.9c-1.6,8.5-69.3,3-151.4-12.2c-82-15.2-147.2-34.4-145.7-42.9C-69,161.7-1.3,167.2,80.8,182.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018917423930930194200000007816892554461489794_",
    cx: 5056.8408,
    cy: 1043.2896,
    r: 45.4674,
    gradientTransform: "matrix(0.3514 -0.1641 1.5863 3.3946 -3260.1187 -2619.8525)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000018917423930930194200000007816892554461489794_)"
    },
    d: "M186,85.3 c35.3,75.6,57.6,139.8,49.8,143.5c-7.8,3.7-42.8-54.6-78.1-130.2C122.3,22.9,100.1-41.3,107.9-45C115.7-48.6,150.7,9.7,186,85.3z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000122699164611248425890000008485559917563951769_",
    cx: 3902.6433,
    cy: 962.4136,
    r: 30.2,
    gradientTransform: "matrix(0.2237 -0.3168 3.0615 2.1603 -3483.6631 -553.6619)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000122699164611248425890000008485559917563951769_)"
    },
    d: "M341.8,280.6 c45.3,31.9,79.3,61.6,76,66.3c-3.3,4.7-42.7-17.4-88-49.4c-45.3-31.9-79.3-61.6-76-66.3C257.1,226.6,296.5,248.7,341.8,280.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008145989378111025250000003381197271890768058_",
    cx: 2617.2979,
    cy: 915.1887,
    r: 30.1986,
    gradientTransform: "matrix(0.3061 -0.2382 2.3022 2.9563 -2614.8955 -1782.9915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000008145989378111025250000003381197271890768058_)"
    },
    d: "M301.4,292.8 c34,43.7,58,82,53.4,85.5c-4.5,3.5-35.8-29.1-69.8-72.8c-34-43.7-58-82-53.4-85.5C236.1,216.5,267.4,249,301.4,292.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078752535033012975660000013569025364299257504_",
    cx: 460.0634,
    cy: 855.1075,
    r: 45.4673,
    gradientTransform: "matrix(6.960000e-02 -0.2695 2.2978 0.5933 -1667.8297 -125.2625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000078752535033012975660000013569025364299257504_)"
    },
    d: "M331.9,247.2 c51.2,13.2,91.4,28.8,89.8,34.8c-1.5,6-44.3,0.2-95.4-13.1c-51.2-13.2-91.4-28.8-89.8-34.8C238,228.2,280.7,234,331.9,247.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000032617536170662634770000001639161267344678029_",
    cx: 41.7051,
    cy: 613.9056,
    r: 45.4696,
    gradientTransform: "matrix(2.600000e-03 -0.2783 2.3731 2.200000e-02 -1320.3584 228.0456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000032617536170662634770000001639161267344678029_)"
    },
    d: "M136.7,218.7 c52.8,0.5,95.6,5.9,95.6,12.1c-0.1,6.2-42.9,10.8-95.8,10.3c-52.8-0.5-95.6-5.9-95.6-12.1C41,222.9,83.9,218.2,136.7,218.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155838740009564735510000008444517346552753832_",
    cx: 7001.9678,
    cy: 181.2243,
    r: 17.5271,
    gradientTransform: "matrix(-0.5477 -8.700000e-02 0.5872 -3.7007 3978.3718 1417.3341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000155838740009564735510000008444517346552753832_)"
    },
    d: "M241.3,136.2 c5-31.8,12.9-56.9,17.6-56.2c4.7,0.7,4.4,27.1-0.6,58.9c-5,31.8-12.9,56.9-17.6,56.2C236,194.3,236.3,167.9,241.3,136.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013192634767382621240000003660899465214109837_",
    cx: 6884.5073,
    cy: -419.1622,
    r: 17.5261,
    gradientTransform: "matrix(0.326 -0.6507 4.368 2.1876 -271.5843 5576.1304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000013192634767382621240000003660899465214109837_)"
    },
    d: "M146.9,169.3 c37.5,18.8,65.6,38.5,62.8,44.1c-2.8,5.6-35.5-5.1-72.9-23.9C99.3,170.8,71.2,151,74,145.4C76.8,139.8,109.4,150.5,146.9,169.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000112621869999727172540000017371520400228686466_",
    cx: 14091.4111,
    cy: -207.6999,
    r: 17.5278,
    gradientTransform: "matrix(-7.260000e-02 -0.1596 3.4098 -1.5535 2065.3325 2102.3828)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000112621869999727172540000017371520400228686466_)"
    },
    d: "M333,173.6 c29.3-13.3,53.5-23,54.1-21.7c0.6,1.4-22.6,13.3-51.9,26.6c-29.3,13.3-53.5,23-54.1,21.7C280.5,198.8,303.7,186.9,333,173.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094586190106584258480000003643257968630490555_",
    cx: 11281.8418,
    cy: 130.8819,
    r: 10.1563,
    gradientTransform: "matrix(-0.172 -3.400000e-02 0.7243 -3.6763 2095.0378 1029.844)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDD00C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01840907,
    style: {
      stopColor: "#CED316",
      stopOpacity: 0.9816
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08885998,
    style: {
      stopColor: "#CFDE37",
      stopOpacity: 0.9111
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1674,
    style: {
      stopColor: "#D1E854",
      stopOpacity: 0.8326
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2546,
    style: {
      stopColor: "#D2F06B",
      stopOpacity: 0.7454
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#D3F67D",
      stopOpacity: 0.6456
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#D4FA8A",
      stopOpacity: 0.526
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6339,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3661
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000094586190106584258480000003643257968630490555_)"
    },
    d: "M247.8,164.8 c3.6-18.3,7.2-33,8.1-32.8c0.9,0.2-1.4,15.1-5,33.4c-3.6,18.3-7.2,33-8.1,32.8C242,198,244.2,183.1,247.8,164.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138543884735752812990000010778101954717002890_",
    cx: 7333.1211,
    cy: 138.2227,
    r: 17.5274,
    gradientTransform: "matrix(-0.8021 -3.740000e-02 0.1742 -3.7429 6087.7773 1071.9467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000138543884735752812990000010778101954717002890_)"
    },
    d: "M217.5,279.8 c1.5-32.1,8.3-57.9,15.2-57.6c6.9,0.3,11.3,26.6,9.8,58.7c-1.5,32.1-8.3,57.9-15.2,57.6C220.4,338.2,216,311.9,217.5,279.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000068652547474974366560000013710134076710645420_",
    cx: 7565.0845,
    cy: 164.9473,
    r: 17.5286,
    gradientTransform: "matrix(-0.415 6.070000e-02 -0.5429 -3.7074 3477.8823 469.6769)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000068652547474974366560000013710134076710645420_)"
    },
    d: "M242.4,318.3 c-4.7-31.8-5.5-58-2-58.6c3.6-0.5,10.2,24.8,14.9,56.7c4.7,31.8,5.5,58,2,58.6C253.7,375.5,247,350.1,242.4,318.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000037671836858873471050000014316977616920254909_",
    cx: 9158.9121,
    cy: 76.5123,
    r: 17.5292,
    gradientTransform: "matrix(-0.4015 -0.1213 1.0833 -3.5869 3804.3486 1668.2834)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000037671836858873471050000014316977616920254909_)"
    },
    d: "M203.7,281 c9.3-30.8,19.6-54.9,23.1-53.9c3.4,1-1.3,26.8-10.6,57.6c-9.3,30.8-19.6,54.9-23.1,53.9C189.6,337.6,194.4,311.8,203.7,281z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000172413170815925235690000003912874687045525143_",
    cx: 9601.9941,
    cy: 30.3289,
    r: 17.5287,
    gradientTransform: "matrix(-0.3616 -0.2126 1.8986 -3.2303 3694.4438 2304.8665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000172413170815925235690000003912874687045525143_)"
    },
    d: "M274.3,162.2 c16.3-27.7,32-48.7,35.1-46.9c3.1,1.8-7.6,25.8-23.9,53.5c-16.3,27.7-32,48.7-35.1,46.9C247.3,213.9,258,189.9,274.3,162.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002354446896216841780000001503787415113279890_",
    cx: 4261.4575,
    cy: 430.0628,
    r: 17.5267,
    gradientTransform: "matrix(-0.2088 -0.5138 3.9563 -1.6083 -483.9306 3073.2556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000002354446896216841780000001503787415113279890_)"
    },
    d: "M324.5,184.1 c34-13.8,62.9-21.4,64.7-17c1.8,4.4-24.3,19.2-58.2,33c-34,13.8-62.9,21.4-64.7,17C264.5,212.6,290.5,197.9,324.5,184.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078032390336484551430000011370567573867167627_",
    cx: 7341.5332,
    cy: 169.854,
    r: 17.5272,
    gradientTransform: "matrix(-0.5537 3.080000e-02 -0.2377 -4.2641 4339.3638 635.6611)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000078032390336484551430000011370567573867167627_)"
    },
    d: "M225.4,138 c-2-36.6,0.2-66.5,4.9-66.7c4.8-0.3,10.3,29.2,12.3,65.8c2,36.6-0.2,66.5-4.9,66.7C232.9,204,227.4,174.6,225.4,138z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011740557261770210060000011612076920214722947_",
    cx: 5555.439,
    cy: 881.7261,
    r: 17.5275,
    gradientTransform: "matrix(0.4398 -0.3378 2.2827 2.9714 -4274.8462 -592.0549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000011740557261770210060000011612076920214722947_)"
    },
    d: "M188,146 c19.6,25.5,32.4,48.5,28.6,51.4c-3.8,2.9-22.7-15.4-42.3-40.9c-19.6-25.5-32.4-48.5-28.6-51.4C149.5,102.2,168.4,120.5,188,146z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085929686907637285750000003950771418487156150_",
    cx: -7317.7905,
    cy: 403.7226,
    r: 10.7528,
    gradientTransform: "matrix(-6.610000e-02 8.710000e-02 -2.9861 -2.2634 887.7217 1728.4243)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000085929686907637285750000003950771418487156150_)"
    },
    d: "M165.2,178.1 c-15.7-11.9-28.2-22-27.8-22.4c0.3-0.5,13.4,8.8,29.1,20.7c15.7,11.9,28.2,22,27.8,22.4C194,199.3,181,190,165.2,178.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057854918390930526970000009677463816853334708_",
    cx: 1960.8905,
    cy: -491.0394,
    r: 75.3961,
    gradientTransform: "matrix(0.4186 0.9082 -1.076 0.496 -1029.7942 -1352.5331)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000057854918390930526970000009677463816853334708_)"
    },
    points: "305.6,189.4  305.5,189.3 471.2,112.9 471.3,113.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054945916163037782940000017910525849355512758_",
    gradientUnits: "userSpaceOnUse",
    x1: 2240.0186,
    y1: -1372.9807,
    x2: 2240.0186,
    y2: -1586.2006,
    gradientTransform: "matrix(-0.1347 0.9909 -0.9421 -0.1281 -712.5974 -2162.1697)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000054945916163037782940000017910525849355512758_)"
    },
    points: "279.1,233.4  279.2,233.2 480,260.6 480,260.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000174560013450411056540000015221302985545834681_",
    cx: 1523.7153,
    cy: -3591.4673,
    r: 75.3949,
    gradientTransform: "matrix(-0.9166 0.3997 -0.256 -0.5869 753.7657 -2394.8914)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000174560013450411056540000015221302985545834681_)"
    },
    points: "255.1,280.4  255.3,280.3 309.9,405.5 309.7,405.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183238462200057676430000002806656874093918392_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.4711,
    y1: -3529.3394,
    x2: 793.4711,
    y2: -3742.5583,
    gradientTransform: "matrix(-0.9931 -0.1175 7.930000e-02 -0.6705 1295.2883 -2009.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183238462200057676430000002806656874093918392_)"
    },
    points: "227.3,263.9 227.5,263.9  210.6,406.8 210.4,406.8  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000019637420075014195890000006938678202798200450_",
    cx: 589.5968,
    cy: -3063.5269,
    r: 75.3936,
    gradientTransform: "matrix(-1.4584 -0.8063 0.761 -1.3762 3391.7678 -3464.8318)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000019637420075014195890000006938678202798200450_)"
    },
    points: "212.6,264.3  212.9,264.5 136.9,401.9 136.6,401.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037660609205451179240000004007747636550136966_",
    gradientUnits: "userSpaceOnUse",
    x1: 806.8022,
    y1: -4630.7153,
    x2: 806.8022,
    y2: -4843.9336,
    gradientTransform: "matrix(-1.6268 -0.3614 9.150000e-02 -0.4117 1947.808 -1315.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000037660609205451179240000004007747636550136966_)"
    },
    points: "211.4,299.1  211.8,299.2 192.3,387 191.9,386.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043431473433270869840000004504551155850676637_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.0511,
    y1: -2174.7029,
    x2: 298.0511,
    y2: -2387.9221,
    gradientTransform: "matrix(-0.8927 -1.4072 0.569 -0.361 1689.5591 -106.5203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000043431473433270869840000004504551155850676637_)"
    },
    points: "186,259  186.2,259.3 64.9,336.2 64.7,336  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127036974850341962990000015945577021047572628_",
    cx: 253.6624,
    cy: -1943.2274,
    r: 75.658,
    gradientTransform: "matrix(-0.6422 -1.5377 0.5382 -0.2247 1354.0497 212.665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000127036974850341962990000015945577021047572628_)"
    },
    points: "145.6,257.5  145.7,257.8 31,305.7 30.9,305.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147924558950328671200000002818805992744226973_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.6583,
    y1: -601.849,
    x2: 254.6583,
    y2: -815.0859,
    gradientTransform: "matrix(0.1834 -1.6563 0.6525 7.220000e-02 513.8622 688.7918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000147924558950328671200000002818805992744226973_)"
    },
    points: "167.9,223.4  167.8,223.7 28.7,208.3 28.7,208  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000122678990036748947630000005040678008790744225_",
    cx: 514.8647,
    cy: 455.979,
    r: 62.6021,
    gradientTransform: "matrix(0.9869 -1.3428 1.2239 0.8996 -883.5735 463.8095)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000122678990036748947630000005040678008790744225_)"
    },
    points: "187.3,193.1  187.1,193.3 65.3,103.8 65.5,103.5  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000145057964213572455080000009929119249765133226_",
    cx: 617.0863,
    cy: 1148.2234,
    r: 75.3821,
    gradientTransform: "matrix(1.1633 -1.1932 0.3929 0.3831 -1030.3469 428.5989)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000145057964213572455080000009929119249765133226_)"
    },
    points: "176.1,162.7 175.9,162.9  92.1,81.2 92.4,81  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026164122426132980050000002286499264920522940_",
    gradientUnits: "userSpaceOnUse",
    x1: 1057.8085,
    y1: 2805.6802,
    x2: 1057.8085,
    y2: 2592.4893,
    gradientTransform: "matrix(1.5787 -0.5335 0.1399 0.4139 -1853.0343 -446.0441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026164122426132980050000002286499264920522940_)"
    },
    points: "209.6,150.8 209.3,150.9  179.5,62.7 179.8,62.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000074439021385975849360000013719613011686929833_",
    cx: 2597.5435,
    cy: -436.4941,
    r: 10.7523,
    gradientTransform: "matrix(6.780000e-02 -8.580000e-02 2.941 2.3217 1409.093 1509.4021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000074439021385975849360000013719613011686929833_)"
    },
    d: "M302.1,272.3 c15.5,12.2,27.8,22.5,27.4,23c-0.4,0.5-13.2-9.1-28.7-21.3c-15.5-12.2-27.8-22.5-27.4-23C273.8,250.5,286.6,260.1,302.1,272.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085212072297641628640000011009109734776733362_",
    cx: 9189.873,
    cy: -302.8076,
    r: 10.752,
    gradientTransform: "matrix(1.540000e-02 -0.1083 3.7102 0.5239 1292.3757 1391.3947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000085212072297641628640000011009109734776733362_)"
    },
    d: "M310.6,236.5 c19.5,2.8,35.3,5.5,35.2,6c-0.1,0.6-16-1.2-35.5-4c-19.5-2.8-35.3-5.5-35.2-6C275.1,231.9,291,233.7,310.6,236.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008862455375628681060000007597977997923126144_",
    cx: 8210.6133,
    cy: -390.952,
    r: 10.756,
    gradientTransform: "matrix(2.900000e-02 -0.1054 3.6134 0.9914 1313.5576 1450.6086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400458,
    style: {
      stopColor: "#F8FFEE",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    style: {
      stopColor: "#EDFED2",
      stopOpacity: 0.8785
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#E4FEBB",
      stopOpacity: 0.7864
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    style: {
      stopColor: "#DDFDA9",
      stopOpacity: 0.6812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    style: {
      stopColor: "#D8FD9C",
      stopOpacity: 0.5549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    style: {
      stopColor: "#D5FD95",
      stopOpacity: 0.3863
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000008862455375628681060000007597977997923126144_)"
    },
    d: "M139.3,196.6 c19,5.2,34.3,9.9,34.2,10.5c-0.2,0.6-15.7-3.2-34.7-8.4c-19-5.2-34.3-9.9-34.2-10.5C104.7,187.6,120.2,191.4,139.3,196.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057109542844512831820000014246123764124538279_",
    gradientUnits: "userSpaceOnUse",
    x1: 923.3922,
    y1: 10389.9795,
    x2: 923.3922,
    y2: 10176.7852,
    gradientTransform: "matrix(-1.0433 1.2994 -0.3407 -0.2735 4789.7866 1902.7354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08501315,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.915
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057109542844512831820000014246123764124538279_)"
    },
    points: "286.4,261.1 286.7,260.8  359.3,319.1 359.1,319.4  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000118382548179937670270000004243068802558858422_",
    cx: 1637.584,
    cy: 1953.6801,
    r: 75.3955,
    gradientTransform: "matrix(1.6278 0.3565 -0.1256 0.5736 -2166.5686 -1542.0754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000118382548179937670270000004243068802558858422_)"
    },
    points: "246.2,180.2  245.9,180.1 272.7,57.8 273,57.9  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026134046977006725270000007121953664253371030_",
    cx: 1965.1097,
    cy: 2526.9231,
    r: 75.5354,
    gradientTransform: "matrix(1.4329 0.8508 -0.2182 0.3675 -1960.8717 -2488.0544)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5E11E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#B1CF1F",
      stopOpacity: 0.8624
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#7CA122",
      stopOpacity: 0.5793
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8209,
    style: {
      stopColor: "#285826",
      stopOpacity: 0.1791
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003528",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000026134046977006725270000007121953664253371030_)"
    },
    points: "289,137.5  288.6,137.5 335.1,59.1 335.5,59.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000076589858519803366660000013312344136898156723_",
    cx: 292.6158,
    cy: 212.6545,
    r: 4.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1468,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0.8532
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076589858519803366660000013312344136898156723_)"
    },
    d: "M297.1,212.7c0,2.5-2,4.5-4.5,4.5 c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C295.1,208.1,297.1,210.2,297.1,212.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000159471047497935256510000013217788167488447105_",
    cx: 105.792,
    cy: 162.9085,
    r: 4.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1468,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0.8532
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000159471047497935256510000013217788167488447105_)"
    },
    d: "M110.3,162.9 c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C108.3,158.4,110.3,160.4,110.3,162.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072244400391753533970000007662636361130850195_",
    cx: 238.4911,
    cy: 280.4895,
    r: 4.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1468,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0.8532
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072244400391753533970000007662636361130850195_)"
    },
    d: "M243,280.5c0,2.5-2,4.5-4.5,4.5 c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C241,276,243,278,243,280.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016768322180641194540000001467814910648306326_",
    cx: 273.3902,
    cy: 161.4535,
    r: 4.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1468,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0.8532
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000016768322180641194540000001467814910648306326_)"
    },
    d: "M277.9,161.5 c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C275.9,156.9,277.9,159,277.9,161.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080186706322296603750000018332813582681912750_",
    cx: 198.3483,
    cy: 96.3788,
    r: 4.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4FD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1468,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0.8532
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080186706322296603750000018332813582681912750_)"
    },
    cx: 198.3,
    cy: 96.4,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031913018938060040900000002515480394660993458_",
    cx: 304.9995,
    cy: 294.0437,
    r: 15.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000031913018938060040900000002515480394660993458_)"
    },
    cx: 305,
    cy: 294,
    r: 15.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130639265886636605050000012762069301899581333_",
    cx: 304.9995,
    cy: 294.0437,
    r: 3.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000130639265886636605050000012762069301899581333_)"
    },
    d: "M308.4,294 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C306.9,290.6,308.4,292.2,308.4,294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109031273062468639020000015789216734386418834_",
    cx: 77.9161,
    cy: 253.5146,
    r: 15.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000109031273062468639020000015789216734386418834_)"
    },
    cx: 77.9,
    cy: 253.5,
    r: 15.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000134949261541730153000000012239531300819904423_",
    cx: 77.9161,
    cy: 253.5152,
    r: 3.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000134949261541730153000000012239531300819904423_)"
    },
    d: "M81.3,253.5 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C79.8,250.1,81.3,251.6,81.3,253.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000001648811628092419160000001235995354917243069_",
    cx: 181.1517,
    cy: 183.429,
    r: 15.7323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000001648811628092419160000001235995354917243069_)"
    },
    cx: 181.2,
    cy: 183.4,
    r: 15.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000137854422701326782580000011683766448339809464_",
    cx: 181.1518,
    cy: 183.429,
    r: 3.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000137854422701326782580000011683766448339809464_)"
    },
    d: "M184.6,183.4 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C183,180,184.6,181.5,184.6,183.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st98"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000050623924621374148170000018292021490845543046_",
    cx: 305.4877,
    cy: 98.2431,
    r: 15.7323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000050623924621374148170000018292021490845543046_)"
    },
    cx: 305.5,
    cy: 98.2,
    r: 15.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000142887800265465732310000002248968641150750083_",
    cx: 305.4877,
    cy: 98.2428,
    r: 3.4107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000142887800265465732310000002248968641150750083_)"
    },
    d: "M308.9,98.2 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C307.4,94.8,308.9,96.4,308.9,98.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st101"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000113334992409377899010000015324731112204568491_",
    cx: 308.5157,
    cy: 245.6773,
    r: 15.7323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000113334992409377899010000015324731112204568491_)"
    },
    cx: 308.5,
    cy: 245.7,
    r: 15.7
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132810507414230978270000015966653860933318053_",
    cx: 308.5157,
    cy: 245.6776,
    r: 3.4107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000132810507414230978270000015966653860933318053_)"
    },
    d: "M311.9,245.7 c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4C310.4,242.3,311.9,243.8,311.9,245.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000103985868838419111650000018247746998732496786_",
    cx: 139.4596,
    cy: 165.8066,
    r: 11.0903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000103985868838419111650000018247746998732496786_)"
    },
    d: "M150.6,165.8 c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1c0-6.1,5-11.1,11.1-11.1C145.6,154.7,150.6,159.7,150.6,165.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000035497896707881035610000004609578051013943734_",
    cx: 139.4596,
    cy: 165.8066,
    r: 2.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000035497896707881035610000004609578051013943734_)"
    },
    d: "M141.9,165.8 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C140.8,163.4,141.9,164.5,141.9,165.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042018273930477964930000011294777658842141619_",
    cx: 163.6454,
    cy: 233.2427,
    r: 11.0903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000042018273930477964930000011294777658842141619_)"
    },
    d: "M174.7,233.2 c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1c0-6.1,5-11.1,11.1-11.1C169.8,222.2,174.7,227.1,174.7,233.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026138033583194613520000014996362437793814423_",
    cx: 163.6454,
    cy: 233.2427,
    r: 2.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000026138033583194613520000014996362437793814423_)"
    },
    d: "M166,233.2 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C165,230.8,166,231.9,166,233.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000091016898299012765640000012764393179495216058_",
    cx: 156.7189,
    cy: 258.0851,
    r: 11.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000091016898299012765640000012764393179495216058_)"
    },
    cx: 156.7,
    cy: 258.1,
    r: 11.1
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000177476679650025893300000016113328655182855355_",
    cx: 156.7189,
    cy: 258.0851,
    r: 2.4044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000177476679650025893300000016113328655182855355_)"
    },
    d: "M159.1,258.1 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C158,255.7,159.1,256.8,159.1,258.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155844969410665924800000002427381245672166067_",
    cx: 256.8299,
    cy: 278.3114,
    r: 11.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000155844969410665924800000002427381245672166067_)"
    },
    cx: 256.8,
    cy: 278.3,
    r: 11.1
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000159471697596338211280000011269705224397199287_",
    cx: 256.8299,
    cy: 278.3114,
    r: 2.4041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000159471697596338211280000011269705224397199287_)"
    },
    d: "M259.2,278.3 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C258.2,275.9,259.2,277,259.2,278.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163769862443548706040000008485935063941030064_",
    cx: 225.0986,
    cy: 306.1214,
    r: 11.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000163769862443548706040000008485935063941030064_)"
    },
    d: "M236.2,306.1 c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1c0-6.1,5-11.1,11.1-11.1C231.2,295,236.2,300,236.2,306.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000025425864868144471690000004086486180170858382_",
    cx: 225.0986,
    cy: 306.1214,
    r: 2.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000025425864868144471690000004086486180170858382_)"
    },
    d: "M227.5,306.1 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C226.4,303.7,227.5,304.8,227.5,306.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040538749125601315530000009586709855555940533_",
    cx: 238.491,
    cy: 304.7067,
    r: 11.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000040538749125601315530000009586709855555940533_)"
    },
    d: "M249.6,304.7 c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1c0-6.1,5-11.1,11.1-11.1C244.6,293.6,249.6,298.6,249.6,304.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000015342547322202603120000015435018693897893258_",
    cx: 238.491,
    cy: 304.7067,
    r: 2.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000015342547322202603120000015435018693897893258_)"
    },
    d: "M240.9,304.7 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C239.8,302.3,240.9,303.4,240.9,304.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085246517295608940880000017959541890717380536_",
    cx: 324.2481,
    cy: 184.9277,
    r: 11.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000085246517295608940880000017959541890717380536_)"
    },
    cx: 324.2,
    cy: 184.9,
    r: 11.1
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048459113528671625210000009624279241926617223_",
    cx: 324.248,
    cy: 184.9277,
    r: 2.4044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000048459113528671625210000009624279241926617223_)"
    },
    d: "M326.7,184.9 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C325.6,182.5,326.7,183.6,326.7,184.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138568365012841029600000008221321170696560535_",
    cx: 326.6525,
    cy: 131.5961,
    r: 11.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000138568365012841029600000008221321170696560535_)"
    },
    d: "M337.7,131.6 c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1c0-6.1,5-11.1,11.1-11.1C332.8,120.5,337.7,125.5,337.7,131.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000050647359069201589710000017043315076667639714_",
    cx: 326.6525,
    cy: 131.5961,
    r: 2.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000050647359069201589710000017043315076667639714_)"
    },
    d: "M329.1,131.6 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4C328,129.2,329.1,130.3,329.1,131.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101805361568011172670000011192327226568452224_",
    cx: 69.2496,
    cy: 94.5697,
    r: 8.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000101805361568011172670000011192327226568452224_)"
    },
    cx: 69.2,
    cy: 94.6,
    r: 8.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157290026407525661290000006401816047406512005_",
    cx: 415.0897,
    cy: 156.9453,
    r: 8.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000157290026407525661290000006401816047406512005_)"
    },
    cx: 415.1,
    cy: 156.9,
    r: 8.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119838898950602134450000017704811492078352288_",
    cx: 48.7585,
    cy: 340.2165,
    r: 8.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000119838898950602134450000017704811492078352288_)"
    },
    cx: 48.8,
    cy: 340.2,
    r: 8.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000111191470622531750670000012874534300031518131_",
    cx: 375.5705,
    cy: 342.4764,
    r: 8.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCCB0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01484555,
    style: {
      stopColor: "#DCCE16",
      stopOpacity: 0.9852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08557928,
    style: {
      stopColor: "#DADB37",
      stopOpacity: 0.9144
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1644,
    style: {
      stopColor: "#D8E554",
      stopOpacity: 0.8356
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2519,
    style: {
      stopColor: "#D6EE6B",
      stopOpacity: 0.7481
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5F57D",
      stopOpacity: 0.648
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#D5F98A",
      stopOpacity: 0.5279
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#D4FC91",
      stopOpacity: 0.3674
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4FD93",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000111191470622531750670000012874534300031518131_)"
    },
    cx: 375.6,
    cy: 342.5,
    r: 8.8
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M335.8,179.8c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C335.7,179.4,335.8,179.6,335.8,179.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M112.8,114c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3S112.8,113.8,112.8,114z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M176.5,168.2c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C176.3,167.9,176.5,168,176.5,168.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M114.8,222.2c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C114.6,221.8,114.8,222,114.8,222.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M182.7,245.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C182.5,245.3,182.7,245.5,182.7,245.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M272.9,256.9c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C272.8,256.6,272.9,256.7,272.9,256.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M210.7,331.4c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3s0.2-0.3,0.3-0.3S210.7,331.2,210.7,331.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M301.9,340.9c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3s0.2-0.3,0.3-0.3S301.9,340.7,301.9,340.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M369.9,245.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C369.8,245.3,369.9,245.5,369.9,245.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M419.7,229.2c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3S419.7,229.1,419.7,229.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M238.8,171.4c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C238.7,171.1,238.8,171.2,238.8,171.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M203.2,201.4c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C203,201.1,203.2,201.3,203.2,201.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M219.3,231.8c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3s0.2-0.3,0.3-0.3 C219.1,231.5,219.3,231.6,219.3,231.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M252,212.7c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C251.9,212.3,252,212.5,252,212.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M241.3,230.6c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C241.1,230.3,241.3,230.4,241.3,230.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 231,
    cy: 210.6,
    r: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 223.4,
    cy: 220.4,
    r: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 230.2,
    cy: 236.6,
    r: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 250,
    cy: 226,
    r: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 239.2,
    cy: 203.4,
    r: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M207,215.9c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 C206.9,215.7,207,215.8,207,215.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M202.7,249.1c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 C202.6,248.9,202.7,249,202.7,249.1z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 236.2,
    cy: 251.7,
    r: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M264.9,244.9c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 C264.8,244.7,264.9,244.8,264.9,244.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M276.6,203.7c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 C276.6,203.6,276.6,203.6,276.6,203.7z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 221.5,
    cy: 267.1,
    r: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 218.6,
    cy: 209.1,
    r: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M265.9,230.8c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6S265.9,230.5,265.9,230.8z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st124",
    cx: 335.1,
    cy: 161.5,
    r: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M114.7,141.3c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 C114.4,140.7,114.7,141,114.7,141.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M157.3,308.5c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 C157,307.9,157.3,308.2,157.3,308.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M327.2,308.5c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 C327,307.9,327.2,308.2,327.2,308.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M378.8,286.8c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 C378.5,286.2,378.8,286.4,378.8,286.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M293.2,182.5c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6 C292.9,181.9,293.2,182.2,293.2,182.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.d573fe93bc1825a41f55a0e4adef092b.svg";
export { ForwardRef as ReactComponent };